import React from "react";
import PropTypes from "prop-types";
import Button from "../../atoms/Button";
import classNames from "../../../utils/classNames";

import "./SettingsLayout.scss";

const SettingsAction = ({
    label,
    description,
    buttonLabel,
    onClick,
    disabled,
    buttonClassName,
    buttonVariant,
}) => (
    <div className="settings-option settings-option--action">
        <div className="settings-option__details">
            <span className="settings-option__label">{label}</span>
            {description && <span className="settings-option__description">{description}</span>}
        </div>
        <div className="settings-option__control">
            <Button
                variant={buttonVariant}
                shape="pill"
                className={classNames(
                    "settings-option__action-button",
                    `settings-option__action-button--${buttonVariant}`,
                    buttonClassName,
                )}
                onClick={onClick}
                disabled={disabled}
            >
                {buttonLabel}
            </Button>
        </div>
    </div>
);

SettingsAction.propTypes = {
    label: PropTypes.string.isRequired,
    description: PropTypes.string,
    buttonLabel: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    buttonClassName: PropTypes.string,
    buttonVariant: PropTypes.oneOf(["primary", "secondary", "danger"]),
};

SettingsAction.defaultProps = {
    description: "",
    onClick: () => {},
    disabled: false,
    buttonClassName: "",
    buttonVariant: "primary",
};

export default SettingsAction;
